import { StyleSheet } from 'aphrodite';

export const triggerAutomationStepRendererStyles = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		gap: 12,
	},
	helpText: {
		margin: 0,
		fontSize: 13,
		color: '#6b7280',
		lineHeight: 1.4,
	},
	loadingText: {
		fontSize: 13,
		color: '#6b7280',
	},
	automationPicker: {
		display: 'flex',
		flexDirection: 'column',
		gap: 10,
	},
	comboboxInputGroupOverride: {
		':has([data-slot="combobox-clear"]) [data-slot="input-group-button"]': {
			display: 'flex',
		},
	},
	templateOptionText: {
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		whiteSpace: 'nowrap' as const,
	},
	selectedAutomationSummary: {
		marginTop: 4,
		padding: '10px 12px',
		backgroundColor: '#F9FAFB',
		borderRadius: 6,
		border: '1px solid #E5E7EB',
	},
	selectedAutomationLabel: {
		marginBottom: 8,
		fontSize: 12,
		fontWeight: 600,
		color: '#374151',
	},
});
